import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { SITE_CONFIG } from '../data/content';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const links = [
    { name: 'Home', path: '/' },
    { name: 'Back Pain', path: '/back-pain' },
    { name: 'Neck Pain', path: '/neck-pain' },
    { name: 'Headaches', path: '/headaches-migraines' },
    { name: 'Dry Needling', path: '/myofascial-dry-needling' },
  ];

  return (
    <nav className="bg-white/95 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <img src={SITE_CONFIG.logo} alt={SITE_CONFIG.chiropracticBrand} className="h-10 md:h-14 w-auto" />
            </Link>
          </div>
          
          <div className="hidden lg:flex items-center space-x-6">
            {links.map((link) => (
              <Link 
                key={link.name} 
                to={link.path}
                className={`text-[11px] font-bold uppercase tracking-wider transition-colors ${location.pathname === link.path ? 'text-teal-600' : 'text-gray-600 hover:text-teal-600'}`}
              >
                {link.name}
              </Link>
            ))}
            <a 
              href={SITE_CONFIG.bookingUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-teal-700 transition-all shadow-md"
            >
              BOOK ONLINE
            </a>
          </div>

          <div className="flex items-center lg:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 p-2">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="lg:hidden bg-white border-t"
          >
            <div className="px-4 py-6 space-y-4">
              {links.map((link) => (
                <Link 
                  key={link.name} 
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="block text-lg font-bold text-gray-800 hover:text-teal-600"
                >
                  {link.name}
                </Link>
              ))}
              <a 
                href={SITE_CONFIG.bookingUrl}
                className="block w-full bg-teal-600 text-white text-center py-4 rounded-xl font-bold"
              >
                BOOK APPOINTMENT
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;